import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import TherapyServices from "@/pages/TherapyServices";
import SportsPerformance from "@/pages/SportsPerformance";
import Fees from "@/pages/Fees";
import Scheduling from "@/pages/Scheduling";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CancellationPolicy from "@/pages/CancellationPolicy";
import Admin from "@/pages/Admin";
import ComingSoon from "@/pages/ComingSoon";
import { Toaster } from "@/components/ui/sonner";

// Set this to false when ready to launch the full site
const COMING_SOON_MODE = true;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout component that conditionally shows Header/Footer
function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdminPage = pathname === '/admin';
  const isComingSoon = pathname === '/coming-soon' || COMING_SOON_MODE;

  if (isAdminPage || isComingSoon) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  // Coming Soon Mode - only show coming soon page and admin
  if (COMING_SOON_MODE) {
    return (
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<ComingSoon />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    );
  }

  // Full Site Mode
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/therapy-services" element={<TherapyServices />} />
            <Route path="/sports-performance" element={<SportsPerformance />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/scheduling" element={<Scheduling />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cancellation-policy" element={<CancellationPolicy />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
